import { IShimmerColors, IShimmerElement, Shimmer, ShimmerElementType } from "@fluentui/react";
import { DonutChart, IDonutChartProps } from "@fluentui/react-charting";
import * as React from "react";

interface IFluentDonutChartProps extends IDonutChartProps {
  isChartLoading?: boolean;
}

const FluentDonutChart = (props: IFluentDonutChartProps) => {
  const shimmerElementsForChart: IShimmerElement[] = [
    { type: ShimmerElementType.gap, width: "100%" },
    { type: ShimmerElementType.circle, height: props.height || 150, width: "100%" },
    { type: ShimmerElementType.gap, width: "100%" }
  ];
  const shimmerElementsForLegends: IShimmerElement[] = [
    { type: ShimmerElementType.gap, height: 16, width: "50%" },
    { type: ShimmerElementType.line, height: 16, width: "20%" },
    { type: ShimmerElementType.gap, width: "15%" },
    { type: ShimmerElementType.line, height: 16, width: "60%" },
    { type: ShimmerElementType.gap, width: "50%" },
    { type: ShimmerElementType.line, height: 16, width: "20%" },
    { type: ShimmerElementType.gap, width: "15%" },
    { type: ShimmerElementType.line, height: 16, width: "60%" },
    { type: ShimmerElementType.gap, width: "50%" },
    { type: ShimmerElementType.line, height: 16, width: "20%" },
    { type: ShimmerElementType.gap, width: "15%" },
    { type: ShimmerElementType.line, height: 16, width: "60%" },
    { type: ShimmerElementType.gap, width: "50%" }
  ];
  const fadedShimmerColors: IShimmerColors = {
    shimmer: "var(--shimmer-color)",
    background: "var(--colorCardBodyBackground1)"
  };

  React.useEffect(() => {
    setTimeout(() => {
      const rowgrpElements = document.querySelectorAll("[role=\"listbox\"]");
      rowgrpElements.forEach(function (element) {
        element.setAttribute("aria-busy", "true");
      });
      const grigrpElements = document.querySelectorAll("[role=\"grid\"]");
      grigrpElements.forEach(function (element) {
        element.setAttribute("aria-busy", "true");
      });
    }, 1000);
  }, []);

  return props?.isChartLoading ? (
    <div style={{ marginTop: 32, marginBottom: 24 }}>
      <Shimmer shimmerElements={shimmerElementsForChart} shimmerColors={fadedShimmerColors} />
      <Shimmer
        shimmerElements={shimmerElementsForLegends}
        styles={{ root: { paddingTop: 24 } }}
        shimmerColors={fadedShimmerColors}
      />
    </div>
  ) : (
    props.data && (
      <DonutChart
        {...props}
        legendProps={{
          allowFocusOnLegends: true,
          ...props.legendProps
        }}
        innerRadius={props.innerRadius ?? 35}
        roundCorners={props.roundCorners ?? true}
        hideLabels={props.hideLabels ?? false}
        showLabelsInPercent={props.showLabelsInPercent ?? true}
      />
    )
  );
};

export default FluentDonutChart;
